import {
  SummaryCardGroup,
  QConfigStructureDetail,
  QConfigPublishErrorsAlert,
  DisabledLosInQConfigAlert,
} from '@exam-management/qconfig-detail';
import { Flex } from '@shared/components';

export default function QConfigDetailsPage() {
  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', p: theme.spacing(6), gap: theme.spacing(6) })}>
      <DisabledLosInQConfigAlert />
      <QConfigPublishErrorsAlert />
      <SummaryCardGroup />
      <QConfigStructureDetail />
    </Flex>
  );
}
